import React from 'react'
import Styles from './NewsOne.module.css'
import Driver from '../../../images/News/car-credit-insurance.jpeg'
function NewsOne() {
  return (
    <div className={Styles.main_page} >
      <h1>Hot summer-Hot Offer</h1>

      
        <div className={Styles.image}>
          <img src={Driver} alt='Driver' ></img>
        </div>

      <p>
      Take your body with you and get FREE Additional Driver promotion during this summer.
      </p>
    </div>
  )
}

export default NewsOne
 